import { UnsupportedPinComponentSettings } from '@lessonup/pins-shared';
import {
  IconComponentAudio,
  IconComponentFormula,
  IconComponentHotspot,
  IconComponentImage,
  IconComponentShape,
  IconComponentSpinner,
  IconComponentTable,
  IconComponentText,
  IconComponentTimer,
  IconComponentTraffic,
  IconComponentVideo,
  IconSlideTypeDragAndDrop,
} from '@lessonup/ui-components';
import React, { JSX } from 'react';

export function mapOriginalTypeToIcon(originalType: UnsupportedPinComponentSettings['originalType']): JSX.Element {
  switch (originalType) {
    case 'spinner':
      return <IconComponentSpinner />;
    case 'text':
      return <IconComponentText />;
    case 'image':
      return <IconComponentImage />;
    case 'hotspot':
      return <IconComponentHotspot />;
    case 'timer':
      return <IconComponentTimer />;
    case 'audio':
      return <IconComponentAudio />;
    case 'symbol':
      return <IconComponentShape />;
    case 'trafficlight':
      return <IconComponentTraffic />;
    case 'dropzone':
      return <IconSlideTypeDragAndDrop />;
    case 'video':
      return <IconComponentVideo />;
    case 'formula':
      return <IconComponentFormula />;
    case 'table':
      return <IconComponentTable />;
  }
}
